<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="DIAS FESTIVOS" key="1">
        <a-row>
          <g-master name="dias_festivos"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    ref="master"
                    @action="masterAction"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-show="false" v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Codigo')">
                    <a-input style="width: 100%;"
                             v-decorator="['tcal_codigo', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown v-bind="fiOptions"
                              endpoint="hierarchy_lookup"
                              :label="$t('País')"
                              :formItemConfig="fiOptions"
                              :decorator="['country', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                              :params="country">
                  </g-dropdown>
                </a-col>
                <a-col v-show="visible" v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Fecha')">
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD 00:00:00"
                                   v-decorator="['tcfe_fecha', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                    ></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Año')">
                    <a-input style="width: 100%;"
                             readOnly
                             v-decorator="['tcfe_ano', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-row>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        visible: false,
        country: {
          h_lookup_type: 'COUNTRY_PROCESS',
          use_code: true
        },
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 24},
        master: {
          endpoint: 'tipical_holidays',
          tableSetup: {
            tableConfig: {
              rowKey: 'tcfe_consec'
            },
            columns: [
              {title: 'Pais', dataIndex: 'pais', sorter: true},
              {title: 'Fecha', dataIndex: 'fecha_desc', sorter: true},
              {title: 'Año', dataIndex: 'tcfe_ano', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'country'},
            {name: 'tcfe_fecha'},
            {name: 'tcfe_ano'},
            {name: 'tcal_codigo'}
          ]
        }
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.visible = true
            this.$refs.master.modal.form.setFieldsValue({
              tcal_codigo: 1
            })
            break
          case 'masterEdit':
            this.visible = false
            break
          case 'fieldsChange':
            if (Object.keys(action.changedFields).length > 1) {
              break
            }
            if (action.changedFields.hasOwnProperty('tcfe_fecha')) {
              const moonLanding = new Date(action.changedFields.tcfe_fecha.value)
              this.$refs.master.modal.form.setFieldsValue({
                tcfe_ano: moonLanding.getFullYear()
              })
            }
            break
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/DiasFestivos/DiasFestivos.vue